// extracted by mini-css-extract-plugin
export var divider = "contacts-module--divider--5oFpE";
export var img = "contacts-module--img--fSeN4";
export var hoverOverMe = "contacts-module--hoverOverMe--ORj6k";
export var socialDiv = "contacts-module--socialDiv--X6g7J";
export var textDiv = "contacts-module--textDiv--OQzGx";
export var row = "contacts-module--row--ieGVS";
export var title = "contacts-module--title--JYcXH";
export var desc = "contacts-module--desc--wRodI";